import RegExPatternValidationRule from './RegExPatternValidationRule';

import validationConst from 'constants/validationConst';

class EmailPatternValidationRule extends RegExPatternValidationRule {
  get pattern() {
    return validationConst.email;
  }
}

export default EmailPatternValidationRule;



// WEBPACK FOOTER //
// ./src/common/core/validation/validationRules/EmailPatternValidationRule.js